import React from 'react'
import { Box, Skeleton } from '@mui/material'
import { SegmentMiniRulesLoader } from '..'

const SegmentHeader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
                ml: 2
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Skeleton variant="text" width={150} height={20} />
                <Skeleton variant="text" width={100} height={20} />
            </Box>
            <SegmentMiniRulesLoader />
        </Box>
    )
}

export default SegmentHeader
